import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedItemProperty = () => {
  return {
    name: null,
    characteristic: false,
  };
};

export default {
  state: () => ({
    selectedItemProperty: getDefaultSelectedItemProperty(),
    itemProperties: [],
  }),

  mutations: {
    setSelectedItemProperty(state, itemProperty) {
      Vue.set(state, "selectedItemProperty", itemProperty);
    },
    setItemProperties(state, itemProperties) {
      Vue.set(state, "itemProperties", itemProperties);
    },
    setDefaultSelectedItemProperty(state) {
      Vue.set(state, "selectedItemProperty", getDefaultSelectedItemProperty());
    },
    setDefaultItemPropertyModule(state) {
      Vue.set(state, "selectedItemProperty", getDefaultSelectedItemProperty());
      Vue.set(state, "itemProperties", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createItemProperty: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/item-properties/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadItemProperties: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/item-properties/entity").then((response) => {
        context.commit("setItemProperties", response.data);
        return response.data;
      });
    },
    loadItemProperty: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-properties/entity/" + request.id).then((response) => {
        context.commit("setSelectedItemProperty", response.data);
      });
    },
    loadPublishedItemProperties: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/item-properties/entity/published").then((response) => {
        //TODO: Loader koyulacak
        context.commit("setItemProperties", response.data);
        return response.data;
      });
    },
    loadItemPropertyHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/item-properties/entity/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },
    loadSelectedItemPropertyHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-properties/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteItemProperty: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/item-properties/entity/" + item.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          item.intents = intents;
          item.intentId = response.data.id;
          return item;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftItemProperty: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/item-properties/draft/" + item.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishItemProperty: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-properties/publish/" + item.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectItemProperty: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-properties/reject/" + item.intentId).then((response) => {
        if (item.intents[0].type === "DELETE_ITEM_PROPERTY") {
          item.intents = null;
          item.intentId = 0;
        } else if (item.intents[0].type === "CREATE_ITEM_PROPERTY") {
          item.intents[0].status = "DRAFT";
        } else if (item.intents[0].type === "UPDATE_ITEM_PROPERTY") {
          item.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    sendToApprovalItemProperty: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-properties/sendToApproval/" + item.intentId).then((response) => {
        if (item.intents[0].type === "CREATE_ITEM") {
          item.intents[0].status = "WAITING_APPROVAL";
        } else if (item.intents[0].type === "UPDATE_ITEM") {
          item.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallItemProperty: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-properties/recall/" + item.intentId).then((response) => {
        helper.recallOrRejectEntity(item, "item_property");
        return response.data;
      });
    },

    cancelItemProperty: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-properties/cancel/" + item.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedItemProperty: (state) => {
      return state.selectedItemProperty;
    },
    getItemProperties: (state) => {
      return state.items;
    },
  },
};
